export const baseURLCNPJ = "https://back-end-company-finder.herokuapp.com/api/CNPJ-search/v1/get-cnpj";
export const baseURLAddressGeocoding = "https://back-end-company-finder.herokuapp.com/api/address-geocoding/v1/get-geocode-address";
export const baseURLGoogle ="https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/geocode/json?address=";
